module.exports = __webpack_public_path__ + "img/SWP_Shield_04.25a937a3.png";